import {useContext} from 'react';

import CheckIcon from '@mui/icons-material/Check';
import {styled, TableCell, Typography} from '@mui/material';

import {BasicTableRow} from '../../../components/BasicTable/BasicTableRow';
import {TextOverflowWithTooltip} from '../../../components/TextOverflowWithTooltip/TextOverflowWithTooltip';
import {LanguageContext} from '../../../contexts/LanguageContext/LanguageContext';
import {CompanyModule, isScreeningApplicantModule} from '../../../types/CompanyProductConfiguration/CompanyModule';

interface CompanyModuleRowProps {
  id: string;
  module: CompanyModule;
}

const StyledCell = styled(TableCell)(() => ({
  paddingTop: '16px',
  paddingBottom: '16px',
  alignContent: 'flex-start',
  maxWidth: '80px',
}));

export const CompanyModuleRow = ({module}: CompanyModuleRowProps) => {
  const currentLanguage = useContext(LanguageContext);

  const limit = isScreeningApplicantModule(module) ? (
    `${module.metaData.currentApplicantCount} / ${module.metaData.maxApplicantLimit}`
  ) : (
    <CheckIcon fontSize='small' />
  );

  return (
    <BasicTableRow rowVariant='flat'>
      <StyledCell>
        <TextOverflowWithTooltip variant='body2' text={module.name[currentLanguage]} />
      </StyledCell>

      <StyledCell>
        <Typography variant='body2'>{limit}</Typography>
      </StyledCell>
    </BasicTableRow>
  );
};
